import React from "react"

import Box from "~components/shared/todo-lib-react-components/box"

import type { PropsWithChildrenAndStyle } from "./types"

interface Props extends PropsWithChildrenAndStyle {
    readonly shouldRender?: boolean
}

export default function ConditionalRenderContainer({
    shouldRender = false,
    children = null,
    style,
}: Props) {
    if (!shouldRender) return null

    return <Box style={style}>{children}</Box>
}
